import _ from 'lodash';

const errorHandler = store => next => action => {
  if (_.isObject(action) && action.type === '@@redux-form/SET_SUBMIT_FAILED') {
    window.scrollTo(0, 0);
  }
  next(action);
};
export default errorHandler;
